module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"email":"Email","phone":"Telefone","idNumber":"CPF"},"cl":{"email":"Email","phone":"Teléfono","idNumber":"Rut"},"pe":{"email":"Email","phone":"Teléfono","idNumber":"DNI/CE"}}')
  delete Component.options._Ctor
}
